/**
 * Model domenowy kartoteki „Zadania" — statusy, priorytety i tryby resetu numeracji.
 * Kody statusów i priorytetów (lista i typy) żyją w `@saas/shared` (`core-field-domains`);
 * etykiety idą przez i18n (`tenant.tasks.status.*`, `tenant.tasks.priority.*`, `tenant.tasks.types.reset.*`).
 */

import { TASK_PRIORITIES, TASK_STATUSES, type TaskPriority, type TaskStatus } from '@saas/shared';

export type TaskNumberingReset = 'continuous' | 'yearly' | 'monthly';

export const TASK_NUMBERING_RESETS: readonly TaskNumberingReset[] = [
  'continuous',
  'yearly',
  'monthly',
];

export function isTaskStatus(value: string): value is TaskStatus {
  return (TASK_STATUSES as readonly string[]).includes(value);
}

export function isTaskPriority(value: string): value is TaskPriority {
  return (TASK_PRIORITIES as readonly string[]).includes(value);
}

/**
 * Priorytet i status nowego zadania, gdy pole nie ma wartości domyślnej (Ustawienia kartoteki → Pola).
 */
export const DEFAULT_TASK_PRIORITY: TaskPriority = 'normal';
export const DEFAULT_TASK_STATUS: TaskStatus = 'new';
